"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textStyles = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var cssObjects = {
    h1: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "], ["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.weight.bold;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h1.fontSize;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h1.margin;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h1.padding;
    }),
    h2: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "], ["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.weight.bold;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h2.fontSize;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h2.margin;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h2.padding;
    }),
    h3: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "], ["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.weight.bold;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h3.fontSize;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h3.margin;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h3.padding;
    }),
    h4: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "], ["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.weight.bold;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h4.fontSize;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h4.margin;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h4.padding;
    }),
    h5: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n        text-transform: uppercase;\n    "], ["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n        text-transform: uppercase;\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.weight.bold;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h5.fontSize;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h5.margin;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h5.padding;
    }),
    h6: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n        text-transform: uppercase;\n    "], ["\n        font-weight: ", ";\n        font-size: ", ";\n        margin: ", ";\n        padding: ", ";\n        text-transform: uppercase;\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.weight.bold;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h6.fontSize;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h6.margin;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.h6.padding;
    }),
    jumbo: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.sansSerif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.jumbo.fontSize;
    }),
    big: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.sansSerif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.big.fontSize;
    }),
    normal: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.sansSerif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.normal.fontSize;
    }),
    small: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.sansSerif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.small.fontSize;
    }),
    micro: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.sansSerif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.micro.fontSize;
    }),
    notification: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.sansSerif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.notification.fontSize;
    }),
    quote: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.serif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.quote.fontSize;
    }),
    author: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n    "], ["\n        font-family: ", ";\n        font-size: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.typography.font.family.serif;
    }, function (_a) {
        var theme = _a.theme;
        return theme.typography.textStyles.author.fontSize;
    }),
};
var boldIt = function (Container) {
    return function (_a) {
        var children = _a.children;
        return (react_1.default.createElement(Container, null,
            react_1.default.createElement("b", null, children)));
    };
};
// allows <textStyles.Jumbo>bla</textStyles.Jumbo>
// <textStyles.Jumbo.Bold>bla</textStyles.Jumbo.Bold>
// and ${textStyles.css} // for use in css blocks
var packStyle = function (key) {
    var BaseComponent = styled_components_1.default.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n        ", "\n    "], ["\n        ", "\n    "])), cssObjects[key]);
    return Object.assign(BaseComponent, {
        css: cssObjects[key],
        Bold: boldIt(BaseComponent),
    });
};
// only holding css for headers
var H1 = { css: cssObjects.h1 };
var H2 = { css: cssObjects.h2 };
var H3 = { css: cssObjects.h3 };
var H4 = { css: cssObjects.h4 };
var H5 = { css: cssObjects.h5 };
var H6 = { css: cssObjects.h6 };
// hold component, css, and bold component for rest
var Jumbo = packStyle('jumbo');
var Big = packStyle('big');
var Normal = packStyle('normal');
var Small = packStyle('small');
var Micro = packStyle('micro');
var Notification = packStyle('notification');
var Quote = packStyle('quote');
var Author = packStyle('author');
var baseCodeStyles = function (_) { return (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    background-color: ", ";\n    color: ", ";\n"], ["\n    font-family: ", ";\n    font-size: ", ";\n    background-color: ", ";\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.code;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.code.fontSize;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastBackgroundColor.toString()
        : 'transparent';
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastColor.toString()
        : 'auto';
}); };
var Code = styled_components_1.default.pre(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", "\n\n    padding: ", ";\n"], ["\n    ", "\n\n    padding: ", ";\n"])), baseCodeStyles, function (_a) {
    var theme = _a.theme;
    return theme.typography.textStyles.code.padding.toString();
});
var InlineCode = styled_components_1.default.code(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    ", "\n\n    display: inline-block;\n    padding: 0 ", ";\n    margin: 0 ", ";\n"], ["\n    ", "\n\n    display: inline-block;\n    padding: 0 ", ";\n    margin: 0 ", ";\n"])), baseCodeStyles, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs.toString();
});
exports.textStyles = {
    H1: H1,
    H2: H2,
    H3: H3,
    H4: H4,
    H5: H5,
    H6: H6,
    Jumbo: Jumbo,
    Big: Big,
    Normal: Normal,
    Small: Small,
    Micro: Micro,
    Notification: Notification,
    Quote: Quote,
    Author: Author,
    Code: Code,
    InlineCode: InlineCode,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
//# sourceMappingURL=textStyles.js.map